<template>
  <slot />
</template>

<script lang="ts" setup>
import { SHARED_THEME_META_COLOR } from '#shared/constants/theme'

const seo = useSeoModule()
const { theme } = useTheme()

useHead({
  htmlAttrs: {
    'data-theme': theme,
  },
  meta: [
    { name: 'theme-color', content: computed(() => SHARED_THEME_META_COLOR[theme.value]) },
  ],
})

useHead({
  link: [
    { rel: 'apple-touch-icon', sizes: '180x180', href: '/favicon/apple-touch-icon.png' },
    { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicon/favicon-32x32.png' },
    { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/favicon/favicon-16x16.png' },
    { rel: 'manifest', href: '/favicon/site.webmanifest' },
    { rel: 'mask-icon', href: '/favicon/safari-pinned-tab.svg', color: '#5bbad5' },
    { rel: 'shortcut icon', href: '/favicon/favicon.ico' },
  ],
  meta: [
    { name: 'msapplication-TileColor', content: '#da532c' },
    { name: 'msapplication-config', content: '/favicon/browserconfig.xml' },
  ],
})

const dynamicHead = computed(() => seo.state.value.useHead)

useHead(dynamicHead)
</script>
